import React, { useEffect, useState } from 'react';
import Button from '../../shared/button/button';
import CustomDatePicker from '../../shared/date-picker/date-picker';
import Select from '../../shared/select/select';
import RadioButtonGroup from '../../shared/radio-button/radio-button';
import { getTimePeriods, isToday } from '../../../utils/time';
import { IsPhysiqueAuthorized } from "../../../utils/auth";
import {
  BOOKING_TIME_TYPES,
  BOOKING_APPOINTMENT_TYPES,
  bookingLabels,
  datePickerFormat,
  telemedecineEcommerceItem,
  visitEcommerceItem,
  bookingCallTypes
} from '../constants';
import {useInView} from "react-intersection-observer";
import {add_to_cart, view_item} from "../../../utils/gtm";

export default function BookingAppointment({ handleSubmit, buttonText, widgetRef }) {
  const isAuth = IsPhysiqueAuthorized();
  const { ref } = useInView({
    triggerOnce: false,
    onChange(inView) {
      if (inView) {
        view_item(telemedecineEcommerceItem);
      }
    }
  });
  const [data, setData] = useState({
    date: new Date(),
    timePeriod: BOOKING_TIME_TYPES.ASAP,
    bookingAppointmentType: BOOKING_APPOINTMENT_TYPES.PHONE
  });

  const timeOptions = getTimePeriods(isToday(data.date));

  useEffect(() => {
    setData({ ...data, timePeriod: timeOptions[0] });
  }, [data.date]);

  const handleChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSubmit = () => {
    add_to_cart({
      ...telemedecineEcommerceItem
    })
    handleSubmit('appointment', data.date, data.timePeriod, null, null, data.bookingAppointmentType);
  };

  return (
    <>
      <div className="booking-widget__grid" ref={ref}>
        <h5>{bookingLabels.bookDate}</h5>
        <RadioButtonGroup
          value={data.bookingAppointmentType}
          name="bookingAppointmentType"
          onChange={handleChange}
          options={bookingCallTypes}
        />
      </div>

      <div className="booking-widget__field-group" ref={ref}>
        <div className="booking-date-picker">
          <CustomDatePicker
            minDate={new Date()}
            value={data.date}
            onChange={handleChange}
            name="date"
            format={datePickerFormat.withWeekendDay}
            isRequired={false}
          />
        </div>
        <Select
          className="select-small"
          name="timePeriod"
          value={data.timePeriod}
          onChange={handleChange}
          options={timeOptions}
          isRequired={false}
        />
      </div>

      <div className="booking-widget-button booking-widget__content-button">
        <Button onClick={onSubmit} type="white" text={buttonText} />
        <div>
          {data.timePeriod === BOOKING_TIME_TYPES.ASAP && <p className="eta-label tpg_b2">{bookingLabels.liveEta}</p>}
          {!isAuth && <p className="eta-label tpg_b2">
            Already a member? <a href="/login" className="login-label tpg_b2">
              Log in
            </a>
          </p>}
        </div>
      </div>
    </>
  );
}
